import axios from 'axios';
import store from 'redux/store';
import { authAgent, getAccessTokenSilent } from 'auth/authUtils';
import { authenticatingUserSuccess } from 'redux/actions/auth';

const qdashAxios = axios.create({
    timeout: 120000,
    headers: { 'content-type': 'application/json' },
});

qdashAxios.interceptors.request.use(
    async (config) => {
        const state = store.getState();
        const accessToken = state.user.accessToken;
        const expiresOn = state.user.accessTokenExpiresOn;

        if (expiresOn && expiresOn < new Date()) {
            let accessTokenResult = await getAccessTokenSilent(authAgent);
            store.dispatch(
                authenticatingUserSuccess(
                    accessTokenResult.accessToken,
                    accessTokenResult.expiresOn,
                    accessTokenResult.account.name,
                    accessTokenResult.account.userName
                )
            );
            config.headers.common['Authorization'] = `Bearer ${accessTokenResult.accessToken}`;
            return config;
        }

        if (accessToken) {
            config.headers.common['Authorization'] = `Bearer ${accessToken}`;
        }

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default qdashAxios;
